import React, { useRef, useEffect } from 'react';
import { useFormContext } from '../Provider';
import useValidators from '../Validators/useValidator';
import CommonFieldWrapper from './CommonFieldWrapper';
import { useConditionalHelper } from '../Conditional';
import { useFieldPanelHelper } from '../../Containers/Accordion/Panel';
import { useKeyboardHelper } from '../../Mobile';

const fallbackValue = '';

const TextField = ({label, name, help, onChange, placeholder, disabled, validators, maxHeight = null}) => {
    const { formData, updateField, updateValidity, isValidating, isSubmitting, formDisabled } = useFormContext();
    const {hideNav, showNav} = useKeyboardHelper(`form-field-${name}`);
    const value = formData[name] ?? fallbackValue;
    const {isValid, error} = useValidators(value, validators, name, updateValidity);
    const fieldRef = useRef();

    useConditionalHelper(name);
    useFieldPanelHelper(name, value, isValid);

    useEffect(() => {
        if (fieldRef.current) {
            fieldRef.current.style.height = '1px';
            fieldRef.current.style.height = `max(1.5rem, ${fieldRef.current.scrollHeight}px)`;
        }
    }, [value]);

    const handleChange = (e) => {
        updateField(name, e.target.value);
        onChange && onChange(e.target.value);
    }

    const isDisabled = formDisabled || disabled || isSubmitting;

    return <CommonFieldWrapper {...{label, name, help, value, isValid, isValidating, error, validators, isDisabled}}>

        <textarea className="block w-full border-0 p-0 surface-1 focus:ring-0 sm:text-sm sm:leading-6"
            ref={fieldRef}
            style={{maxHeight}}
            value={value}
            onChange={handleChange}
            placeholder={placeholder}
            disabled={isDisabled}
            onFocus={hideNav}
            onBlur={showNav}
        />

    </CommonFieldWrapper>
}

export default TextField;
